import React, { useState, useEffect } from "react";
import DEATH_API from "../../apis/death.api";
import moment from "moment";
import swal from "sweetalert";
import { useHistory } from "react-router-dom";
import { PaymentsNew } from "./PaymentsNew";
import "./subscription.css";
import { SubscriptionSkeleton } from "../Skeletons/SubscriptionSkeleton";

export const Subscription = () => {
  const [subscriptionsDetails, setSubscriptionsDetails] = useState([]);
  const [initialLoading, setInitialLoading] = useState(false);
  const [actionLoading, setActionLoading] = useState(false);
  const [dropdown, setDropdown] = useState(false);
  const [selectedIndex, setSelectedIndex] = useState(null);
  const history = useHistory();
  const [subscription, setSubscription] = useState(null);

  const getSelectedRow = (idx) => {
    console.log("idx>>>", idx);
    setSelectedIndex(idx);
    // get selected row (this will return array of object)
    let selectedRow = subscriptionsDetails.filter((row, index) => {
      return row.id == idx;
    });
    // get first and only element from list and store it in update object
    console.log("selectedRow[0]", selectedRow[0]);
    // setUpdateObject(selectedRow[0]);
  };
  const signOut = (e) => {
    // e.preventDefault();
    localStorage.removeItem("userLoginToken");
    localStorage.removeItem("role");
    localStorage.removeItem("delegateUsers");
    localStorage.removeItem("otp");
    localStorage.removeItem("User");
    localStorage.removeItem("fields");
    localStorage.removeItem("accessId");
    localStorage.removeItem("duplicateRole");
    localStorage.removeItem("profile");
    localStorage.removeItem("permissionState");
    localStorage.removeItem("userName");
    localStorage.clear();
    history.push("/login");
  };
  const deleteSelectedRow = async (idx) => {
    if (!idx) {
      return;
    }

    swal({
      title: "Are you sure?",
      text: "You will be logged out and no longer have access to your information.",
      dangerMode: true,
      buttons: ["No!", "Yes!"],
      icon: "warning",
      type: "warning",
      closeOnConfirm: false,
      closeOnCancel: false,
    }).then(async function (isConfirm) {
      if (isConfirm) {
        let res = null;
        try {
          setActionLoading(true);
          res = await DEATH_API.cancelSubscription();
          if (res.status === 200) {
            signOut();
            return;
          }
        } catch (error) {
          console.log(error);
          swal(
            "Error",
            "Unable to cancel subscription right now. Please try again.",
            "error"
          );
        } finally {
          setActionLoading(false);
        }

        if (res && res.message) {
          swal(
            "Cancelled!",
            res.message,
            res.message ===
              "Subscription Cannot Be Canceled During Trail Period."
              ? "error"
              : "success"
          );
        }
      } else {
        swal("Cancelled", "Your Subscription is safe :)", "error");
      }
    });
  };
  const getSubscriptionDetails = async () => {
    try {
      setInitialLoading(true);
      let data = await DEATH_API.getSubscriptionList();
      if (data && data.data) {
        setSubscriptionsDetails(data.data);
        setSubscription(data.data[0]);
      }
    } catch (error) {
      console.log(error);
    } finally {
      setInitialLoading(false);
    }
  };
  useEffect(() => {
    getSubscriptionDetails();
  }, []);
  return (
    <div className="profileMain">
      {initialLoading ? (
        <SubscriptionSkeleton />
      ) : (
        <>
          <div style={{ display: "flex", justifyContent: "space-between" }}>
            <h1
              style={{ fontFamily: "Poppins", fontSize: "20px", fontWeight: "600" }}
            >
              Subscription Details
            </h1>
          </div>
          <div
            style={{
              padding: "2rem",
              background: "#FFFFFF",
              border: "1px solid #ECECEC",
              borderRadius: "20px",
              boxShadow: "0 12px 32px rgba(17, 24, 39, 0.04)",
            }}
          >
            <div>
              <div className="infocardrow">
                <div className="infocardrowData">
                  <span className="infocardTitle1"> Subscription Plan</span>
                  <span className="infocardsubTitle">
                    {subscription && subscription.subscriptionType}
                  </span>
                </div>
              </div>
              <div className="infocardrow2">
                <div className="infocardrowData">
                  <span className="infocardTitle1"> Subscription Status</span>
                  <span className="infocardsubTitle">
                    {subscription && subscription.subscriptionDescription}
                  </span>
                </div>
                <div className="infocardrowData">
                  <span className="infocardTitle1"> Started On </span>
                  <span className="infocardsubTitle">
                    {subscription &&
                      subscription.startDate &&
                      moment(subscription.startDate).format("MM-DD-YYYY")}
                  </span>
                </div>
              </div>
              <div className="infocardrow2">
                <div className="infocardrowData">
                  <span className="infocardTitle1"> Trial Ended On</span>
                  <span className="infocardsubTitle">
                    {subscription &&
                      subscription.trailEndDate &&
                      moment(subscription.trailEndDate).format("MM-DD-YYYY")}
                  </span>
                </div>
                <div className="infocardrowData">
                  <span className="infocardTitle1"> Last Payment </span>
                  <span className="infocardsubTitle">
                    ${subscription && subscription.amountPaid}
                  </span>
                </div>
              </div>
              <div className="infocardrow2">
                <div className="infocardrowData">
                  <span className="infocardTitle1"> Total Amount</span>
                  <span className="infocardsubTitle">
                    ${subscription && subscription.amountPaid}
                  </span>
                </div>
                <div className="infocardrowData">
                  <span className="infocardTitle1"> Coupon</span>
                  <span className="infocardsubTitle">
                    {subscription && subscription.coupon}
                  </span>
                </div>
              </div>
              <div className="subscriptionButtons">
                <button
                  className="savebutton"
                  style={{
                    textAlign: "center",
                    marginTop: "2rem",
                    fontSize: "12px",
                    fontWeight: "700",
                    padding: "12px 40px",
                    background: "#DC2C2C",
                    opacity: actionLoading ? 0.7 : 1,
                  }}
                  type="submit"
                  disabled={actionLoading || !subscription}
                  onClick={() => {
                    deleteSelectedRow(subscription && subscription.id);
                  }}
                >
                  {actionLoading ? (
                    <span
                      style={{
                        display: "inline-flex",
                        alignItems: "center",
                        gap: "8px",
                      }}
                    >
                      <span className="spinner-border spinner-border-sm" />
                      Cancelling...
                    </span>
                  ) : (
                    "Cancel Subscription"
                  )}
                </button>
                <button
                  className="savebutton"
                  style={{
                    textAlign: "center",
                    marginTop: "2rem",
                    fontSize: "12px",
                    fontWeight: "700",
                    padding: "12px 40px",
                    opacity: actionLoading ? 0.7 : 1,
                  }}
                  type="submit"
                  disabled={actionLoading}
                  onClick={() => {
                    history.push("/payment");
                  }}
                >
                  Upgrade Subscription
                </button>
              </div>
            </div>
          </div>
        </>
      )}
      <PaymentsNew />
      {/*<PaymentMethods /> */}
      {/*<div className="rolesTable" style={{ marginTop: "10px" }}>
        <div className="RolesHeader">
          <div className="RoleTitle">Subscriptions Details</div>
        </div>
        <List cols={cols} rows={subscriptionsDetails} />
        </div>*/}
    </div>
  );
};
